module.exports = __webpack_public_path__ + "media/images/flags/4x3/pry-c9084660110c0c8df345e62e3a117168.svg";